


























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { homeInfo, titleList } from '../api';
let timer: any = null;

@Component
export default class CommentList extends Vue {
  commentList = [];
  copyList = true;
  titles = [];

  async created() {
    const res = await homeInfo();
    await this.getTitleList();
    if ((res as any).code === 200 && res.data.list.length > 0) {
      this.commentList = res.data.list;
      timer = setInterval(() => this.rollStart(), 50);
    }
    timer = setInterval(() => this.rollStart(), 50);
  }
  async getTitleList() {
    const res: any = await titleList();
    this.titles = res.data;
  }
  rollStart() {
    const box = this.$refs.box;
    const list1 = this.$refs.list1;
    const list2 = this.$refs.list2;

    if (box && (box as HTMLElement).scrollHeight / 2 < 200 - 10) {
      this.copyList = false;
    } else {
      if (
        box &&
        (box as HTMLElement).scrollHeight &&
        (box as HTMLElement).scrollTop ===
          Math.floor((box as HTMLElement).scrollHeight / 2 - 10)
      ) {
        (box as HTMLElement).scrollTop = 0;
      } else {
        if (box) {
          (box as HTMLElement).scrollTop++;
        }
      }
    }
  }

  _matchTitle(id: string) {
    return this.titles.filter((item: any) => item.id === id)[0];
  }
  destroyed() {
    clearInterval(timer);
  }
}
